// extracted by mini-css-extract-plugin
export default {"root":"WqxJrzwi","logoContainer":"a6rDaReO","video":"eXGKOKb6"};